import ActionButton from '@jimmyboys/liita-ui/dist/components/ActionButton'
import Dropdown from '@jimmyboys/liita-ui/dist/components/Dropdown'
import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'
import TaskHeaderErrors from 'components/TaskHeaderErrors/TaskHeaderErrors'
import { translateErrorMessage } from 'hooks/useSubmitTask'
import { Options } from 'models'
import { useState } from 'react'
import { useFetchList } from 'store'
import { useReload } from 'store'
import { API_URL, fetchOptions, parseJSONContent } from 'store/fetchUtils'
import styles from './Dialog.module.sass'

const ChangeInjuredStateDialog = (props) => {
	const { className, data, resolve, dismiss } = props
	const { i18n, expireSession, pushNotification } = useGlobal()

	const [submitting, setSubmitting] = useState(false)
	const [injuredState, setInjuredState] = useState(null)
	const [error, setError] = useState(null)
	const reload = useReload()

	const {
		contents: [injuredStates],
	} = useFetchList(
		[`/metadata/injured_states/${data.processId}`],
		[Options.fromSimpleObjectJSON]
	)

	const handleSubmit = (e) => {
		e.preventDefault()
		if (submitting) {
			return
		}
		const url = `${API_URL}/api/clinical_processes/${data?.processId}/injured_state`
		const body = {
			injuredStateId: parseInt(injuredState),
		}

		setError(null)
		setSubmitting(true)
		fetch(
			url,
			fetchOptions({
				method: 'POST',
				body,
			})
		)
			.then((r) => parseJSONContent(r))
			.then(() => {
				reload([`/clinical_processes/${data?.processId}`])
				resolve && resolve()
				pushNotification(
					undefined,
					'success',
					i18n`Injured state changed!`
				)
			})
			.catch((err) => {
				if (err.status === '401' || err.status === 401) {
					expireSession()
				}

				const errorMessage = translateErrorMessage(err, i18n)

				setSubmitting(false)
				setError([errorMessage])
			})
	}

	return (
		<>
			<TaskHeaderErrors errors={error || []} />
			<form
				id={'form_change_injured_state'}
				className={`${styles['root'] || ''} ${className || ''}`}
				onSubmit={handleSubmit}
				disabled={submitting}
			>
				<Dropdown
					placeholder={i18n`Injured state`}
					value={injuredState}
					options={injuredStates || []}
					required
					displayValue={false}
					searchable={true}
					onChange={(e) => {
						setInjuredState(e.target.value)
					}}
				/>
			</form>
			<menu>
				<ActionButton type='button' secondary onClick={dismiss}>
					<small>
						<strong>{i18n`Cancel`}</strong>
					</small>
				</ActionButton>
				<ActionButton form={'form_change_injured_state'} primary>
					<small>
						<strong>
							{submitting ? i18n`Submitting` : i18n`Send`}
						</strong>
					</small>
				</ActionButton>
			</menu>
		</>
	)
}

export default ChangeInjuredStateDialog
